import { useNavigate } from 'react-router-dom'

interface LoginTypeSelectorProps {
  quetureId: string
  wb: string
  idx: string | null
}

export function LoginTypeSelector({ quetureId, wb, idx }: LoginTypeSelectorProps) {
  const navigate = useNavigate()

  const buildRedirect = () => {
    const params = new URLSearchParams({ from: 'QR', wb })
    if (idx) params.set('idx', idx)
    return `/queture/${quetureId}?${params.toString()}`
  }

  const goToLogin = (type: 'student' | 'parent') => {
    const redirect = encodeURIComponent(buildRedirect())
    navigate(`/login?type=${type}&redirect=${redirect}`)
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-sm space-y-6 text-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">깨처 시청</h1>
          <p className="mt-2 text-gray-600">
            깨처를 시청하려면 로그인이 필요합니다
          </p>
        </div>
        <div className="space-y-3">
          <button
            onClick={() => goToLogin('student')}
            className="btn-primary w-full py-3 text-base"
          >
            학습자 로그인
          </button>
          <button
            onClick={() => goToLogin('parent')}
            className="btn-secondary w-full py-3 text-base"
          >
            학부모 로그인
          </button>
        </div>
      </div>
    </div>
  )
}
